import Vue from 'vue'
import VueRouter from 'vue-router'
import firebase from 'firebase'
import axios from 'axios'
// import EventBus from '../components/EventBus'
// import createPopper from '@popperjs/core'

Vue.use(VueRouter)

//const router = new VueRouter ({

const routes = [
  { path: '*', redirect: '/' },
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/buro',
    name: 'Buro',
    component: () => import('../views/Buro.vue')
  },
  {
    path: '/editar',
    name: 'Editar',
    component: () => import('../views/Editar.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/detalles',
    name: 'Detalles',
    component: () => import('../views/Detalles.vue'),
    meta: { requiresAuth: true }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  let usuario = firebase.auth().currentUser
  let autorizacion = to.matched.some(record => record.meta.requiresAuth)

  if (usuario) {
    if (autorizacion && !usuario) {
      next('/login')
    } else {
      next()
    }
  } else {
    axios
      .post('conecta_buro.php')
      .then(resp => {
        // console.log(resp.data)
        if (resp.data === 1) {
          // console.log('Es buro: \n')
          next()
        } else if (resp.data) {
          // console.log('Es firebase: \n')

          if (autorizacion && !usuario) {
            next('/login')
          } else {
            next()
          }
        } else {
          if (autorizacion && !usuario) {
            next('/login')
          } else {
            next()
          }
        }
      })
      .catch(Error => {
        console.log(Error)
        if (autorizacion && !usuario) {
          next('/login')
        } else {
          next()
        }
      })
  }
})

export default router
